import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/heros/hero"
import Bio from "../components/bio"
import Treatments from "../components/treatments"
import Why from "../components/why"
import CallToAction from "../components/callToAction"
import Benefits from "../components/benefits"
import Team from "../components/team"
import Reviews from "../components/reviews"
import FeaturedFaq from "../components/faqs/featuredFaq"
import Hero2 from "../components/heros/hero2"
import Calander from "../components/calander"

export default function Index() {
  return (
    <Layout>
      <SEO title="Massage & Sound Therapy" description="" />
      <Hero />
      <Bio />
      <Treatments />
      <Why />
      <CallToAction />
      <Benefits />
      <Reviews />
      <Team />
      <CallToAction />
      <Calander />
      <FeaturedFaq />
    </Layout>
  )
}
